import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "warranty-replacement-vendor",
  value: "Warranty_Replacement_To_Vendor",
  labelKey: "inventory.transferWarrantyReplacementToVendor",
  party: "vendor",
};

export function WarrantyReplacementToVendorModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
